import { getItemAnimationDelay } from '../../../helpers/get-item-animation-delay';
var SIDEBAR_DELAY_IN_MS = 220;
var NORMALIZE_ARRAY_INDEX = 1;
export var getNavSideBarItemTransitionDelay = function getNavSideBarItemTransitionDelay(itemIndex) {
  var transitionDelayOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return getItemAnimationDelay({
    itemIndex: transitionDelayOffset + itemIndex + NORMALIZE_ARRAY_INDEX,
    delayInMs: SIDEBAR_DELAY_IN_MS,
    multiplier: 8
  });
};